/*
 * Copyright (c) 2024. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import * as L from 'leaflet';
import { GestureHandling } from 'leaflet-gesture-handling';
import { useEffect } from 'react';
import { useMap } from 'react-leaflet';

L.Map.addInitHook('addHandler', 'gestureHandling', GestureHandling);

interface Props {
  enabled?: boolean;
}

function GestureHandlingControl({ enabled = true }: Readonly<Props>) {
  const map = useMap();

  useEffect(() => {
    map.options.gestureHandling = enabled;
    map.options.gestureHandlingOptions = {
      ...(map.options.gestureHandlingOptions ?? {}),
      duration: 1700,
    };

    if (enabled) {
      map.gestureHandling?.enable();
      return;
    }

    map.gestureHandling?.disable();
    map.scrollWheelZoom.enable();
  }, [enabled, map]);

  return null;
}

export default GestureHandlingControl;
